module.exports = __webpack_public_path__ + "img/mbf-socket.bf63c84e.jpg";